import { combineReducers } from 'redux';
import rootReducer from 'fk-cp-common-components/reducers';

export default combineReducers({
	selfServe: rootReducer
});
